import {
    retornaLabelDoValorParentesco,
    validatorMaior79Anos,
    validatorAte64Anos,
    validatorMaiorIgual65Anos,
    validatorMaiorIgual79Anos,
    validatorParentescoEmDuplicidade,
    encontrarCategoriaPorCodigo
} from './funcoesAuxiliaresZTI';

export class CorrenteCadastroZTI {
    constructor(
        dependentes,
        parentesco,
        categorias,
        idadeAssociado,
        valoresForm,
        isValid
    ) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.idadeAssociado = idadeAssociado;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
    }

    possui14Dependentes() {
        const qtdDependentesTotais = this.dependentes.length;

        if (qtdDependentesTotais === 14) {
            this.arrayMsgsErro.push('Este plano permite apenas 14 dependentes.');
        }

        return this;
    }

    possui2VidasMaiorIgual79Anos() {
        if (
            validatorMaiorIgual79Anos(
                this.valoresForm,
                this.dependentes,
                this.idadeAssociado
            )
        ) {
            this.arrayMsgsErro.push(
                'O plano permite apenas 2 pessoas com idade maior ou igual a 80 anos.'
            );
        }

        return this;
    }

    parentescoComAdicionalAte64() {
        if (validatorAte64Anos(this.valoresForm)) {
            this.arrayMsgsErro.push(
                `Para dependentes de até 64 anos, o adicional permitido é o ${encontrarCategoriaPorCodigo(
                    'ZTA64'
                )}.`
            );
        }

        return this;
    }

    parentescoComAdicionalMaiorIgual65() {
        if (validatorMaiorIgual65Anos(this.valoresForm)) {
            this.arrayMsgsErro.push(
                `Para dependentes com idades entre 65 e 79 anos, o adicional permitido é o ${encontrarCategoriaPorCodigo(
                    'ZTA65'
                )}.`
            );
        }

        return this;
    }

    parentescoComAdicionalMaior79() {
        if (validatorMaior79Anos(this.valoresForm)) {
            this.arrayMsgsErro.push(
                `Para dependentes acima de 79 anos, o adicional permitido é o ${encontrarCategoriaPorCodigo(
                    'ZTA79'
                )}.`
            );
        }

        return this;
    }

    parentescoEmDuplicidade() {
        if (validatorParentescoEmDuplicidade(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push(
                `${retornaLabelDoValorParentesco(this.parentesco)}`
            );
        }

        return this;
    }
}
